import React from 'react';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] border-t border-gray-800 mt-20">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 bg-[#D4A843] rounded-lg flex items-center justify-center">
                <Shield className="w-4 h-4 text-[#0A0A0A]" />
              </div>
              <span className="text-white font-bold text-lg">TechOps</span>
            </div>
            <p className="text-xs text-gray-500 leading-relaxed">
              A product of EIGOO Inc. Cybersecurity & IT for small and mid-sized operators.
            </p>
          </div>

          <div>
            <h4 className="text-[10px] font-bold text-[#D4A843] uppercase tracking-wider mb-3">Product</h4>
            <ul className="space-y-2 text-xs text-gray-400">
              <li><Link to="/diagnostics" className="hover:text-white">Free health check</Link></li>
              <li><Link to="/marketplace" className="hover:text-white">Marketplace</Link></li>
              <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
              <li><Link to="/services" className="hover:text-white">Services</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[10px] font-bold text-[#D4A843] uppercase tracking-wider mb-3">Company</h4>
            <ul className="space-y-2 text-xs text-gray-400">
              <li><Link to="/about" className="hover:text-white">About</Link></li>
              <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
              <li><Link to="/join" className="hover:text-white">Join our network</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[10px] font-bold text-[#D4A843] uppercase tracking-wider mb-3">Legal</h4>
            <ul className="space-y-2 text-xs text-gray-400">
              <li><Link to="/privacy" className="hover:text-white">Privacy</Link></li>
              <li><Link to="/terms" className="hover:text-white">Terms</Link></li>
              <li><Link to="/login" className="hover:text-white">Sign in</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-gray-900 text-[10px] text-gray-600 flex flex-col sm:flex-row justify-between gap-2">
          <p>© {new Date().getFullYear()} EIGOO Inc. All rights reserved. Hagåtña, Guam.</p>
          <p>eigooinc.net · techops.eigooinc.net</p>
        </div>
      </div>
    </footer>
  );
}
